export default __webpack_public_path__ + "static/mobileBanner3-dd355a2982669e287e9c1d4db3a6a72f.jpg";